module.exports = "<main #modalParentElement></main>\n<router-outlet></router-outlet>"